module.exports = __webpack_public_path__ + "static/media/2.df70b6f3.jpg";